import { ComponentType } from "react";

import AppointmentCtaSection from "./sections/AppointmentCtaSection";
import AppointmentFormSection from "./sections/AppointmentFormSection";
import BreadcrumbSection from "./sections/BreadcrumbSection";
import CareerFormSection from "./sections/CareerFormSection";
import ConditionsSection from "./sections/ConditionsSection";
import ContactFormSection from "./sections/ContactFormSection";
import ContentSection from "./sections/ContentSection";
import FaqSection from "./sections/FaqSection";
import GoogleReviewsSection from "./sections/GoogleReviewsSection";
import HeroSection from "./sections/HeroSection";
import LinksSection from "./sections/LinksSection";
import MapSection from "./sections/MapSection";
import MarkdownSection from "./sections/MarkdownSection";
import MenuSection from "./sections/MenuSection";
import NewsletterSection from "./sections/NewsletterSection";
import NoticeSection from "./sections/NoticeSection";
import PostDetailSection from "./sections/PostDetailSection";
import PostsSection from "./sections/PostsSection";
import RelatedSection from "./sections/RelatedSection";
import StatsSection from "./sections/StatsSection";
import StepsSection from "./sections/StepsSection";
import TeamSection from "./sections/TeamSection";
import TreatmentsSection from "./sections/TreatmentsSection";
import VideoSection from "./sections/VideoSection";
import PageHeading from "./shared/PageHeading";

/**
 * Static registry of dynamic-zone renderers, keyed by the Strapi component uid.
 *
 * The imports are STATIC on purpose. Computed dynamic imports would not
 * server-render, so every CMS-driven section would be missing from the HTML —
 * which on this site is most of the page, and all of the content the treatment
 * and condition pages exist to rank for.
 */
export const SECTION_COMPONENTS: Record<string, ComponentType<any>> = {
  "sections.appointment-cta-section": AppointmentCtaSection,
  "sections.appointment-form-section": AppointmentFormSection,
  "sections.breadcrumb-section": BreadcrumbSection,
  "sections.career-form-section": CareerFormSection,
  "sections.conditions-section": ConditionsSection,
  "sections.contact-form-section": ContactFormSection,
  "sections.content-section": ContentSection,
  "sections.faq-section": FaqSection,
  "sections.google-reviews-section": GoogleReviewsSection,
  "sections.hero-section": HeroSection,
  "sections.links-section": LinksSection,
  "sections.map-section": MapSection,
  "sections.markdown-section": MarkdownSection,
  "sections.menu-section": MenuSection,
  "sections.newsletter-section": NewsletterSection,
  "sections.notice-section": NoticeSection,
  "sections.post-detail-section": PostDetailSection,
  "sections.posts-section": PostsSection,
  "sections.related-section": RelatedSection,
  "sections.stats-section": StatsSection,
  "sections.steps-section": StepsSection,
  "sections.team-section": TeamSection,
  "sections.treatments-section": TreatmentsSection,
  "sections.video-section": VideoSection,
  "shared.page-heading": PageHeading,
};

export default SECTION_COMPONENTS;
